import { onMessageFromWebApp, sendMessageToWebApp } from "./webAppMessenger";
import {
  DELETE_CREDENTIALS_FROM_KEYCHAIN,
  DELETE_CREDENTIALS_FROM_KEYCHAIN_SUCCESS,
  DELETE_CREDENTIALS_FROM_KEYCHAIN_ERROR,
  GET_CREDENTIALS_FROM_KEYCHAIN,
  GET_CREDENTIALS_FROM_KEYCHAIN_SUCCESS,
  GET_CREDENTIALS_FROM_KEYCHAIN_ERROR,
  SAVE_CREDENTIALS_TO_KEYCHAIN,
  SAVE_CREDENTIALS_TO_KEYCHAIN_SUCCESS,
  SAVE_CREDENTIALS_TO_KEYCHAIN_ERROR
} from "./messageTypes";

import BiometricAuthentication from "../helpers/BiometricAuthentication";

window.biometricAuthentication = new BiometricAuthentication();

onMessageFromWebApp(GET_CREDENTIALS_FROM_KEYCHAIN, async () => {
  try {
    const credentials = await window.biometricAuthentication.getCredentialsFromKeychain();
    sendMessageToWebApp(GET_CREDENTIALS_FROM_KEYCHAIN_SUCCESS, {
      credentials
    });
  } catch (error) {
    console.error("Unable to authenticate biometrically.");
    sendMessageToWebApp(GET_CREDENTIALS_FROM_KEYCHAIN_ERROR, { error });
  }
});

onMessageFromWebApp(SAVE_CREDENTIALS_TO_KEYCHAIN, async ({ credentials }) => {
  console.log(SAVE_CREDENTIALS_TO_KEYCHAIN, credentials);
  try {
    if (!credentials) {
      throw new Error("No Credentials Provided");
    }

    await window.biometricAuthentication.saveCredentialsToKeychain(credentials);
    sendMessageToWebApp(SAVE_CREDENTIALS_TO_KEYCHAIN_SUCCESS);
  } catch (error) {
    console.error("Unable to save credentials.");
    sendMessageToWebApp(SAVE_CREDENTIALS_TO_KEYCHAIN_ERROR, { error });
  }
});

onMessageFromWebApp(DELETE_CREDENTIALS_FROM_KEYCHAIN, async () => {
  try {
    await window.biometricAuthentication.deleteCredenialsFromKeychain();
    sendMessageToWebApp(DELETE_CREDENTIALS_FROM_KEYCHAIN_SUCCESS);
  } catch (error) {
    sendMessageToWebApp(DELETE_CREDENTIALS_FROM_KEYCHAIN_ERROR, { error });
  }
});
